import { BKFCourse } from "../providers/coursesProvider";
import { Form2 } from "../misc/Form2";
import { Button, DialogActions, Grid } from "@mui/material";
import { DateInput, required, TextInput } from "react-admin";
import { SaveButton2 } from "../buttons/SaveButton2";
import { runSafelyWithServerClient } from "../api/server.api";
import { studentsProvider } from "../providers/studentsProvider";
import { date, dateNotInTheFuture, email } from "../utils/validators";

interface AddCourseParticipantFormValues {
  contactData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    city: string;
    postalCode: string;
    street: string;
  };
  dateOfBirth: string;
  placeOfBirth: string;
}

export function AddCourseParticipantForm(props: { course: BKFCourse; onCancel: () => void; onSuccess: () => void }) {
  const { course, onCancel, onSuccess } = props;
  if (location.hostname === "backoffice.autovio.de") {
    return "Diese Funktion ist noch nicht freigeschaltet, wir arbeiten daran ...";
  }
  const onSubmit = async (formValues: AddCourseParticipantFormValues) => {
    await runSafelyWithServerClient(
      async (serverClient) => {
        const { id: bundleId } = await serverClient.getOrCreateCourseBundle({ params: { id: course.id } });
        await studentsProvider.create("students", {
          data: {
            ...formValues,
            drivingSchoolId: course.drivingSchoolId,
            branchId: course.branchId,
            bundleId,
            courseId: course.id,
            paymentSelection: "invoice_payment",
          },
        });
      },
      {
        errorMessage: "Fehler beim Hinzufügen des Teilnehmers.",
        successMessage: "Teilnehmer erfolgreich hinzugefügt.",
        onSuccess,
      },
    );
  };

  return (
    <Form2<AddCourseParticipantFormValues> onSubmit={onSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Vorname"
            source="contactData.firstName"
            validate={required("Bitte gib den Vornamen ein.")}
            autoFocus
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Nachname"
            source="contactData.lastName"
            validate={required("Bitte gib den Nachnamen ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="E-Mail"
            source="contactData.email"
            type="email"
            validate={[required("Bitte gib die E-Mail-Adresse ein."), email()]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Telefonnummer"
            source="contactData.phone"
            validate={required("Bitte gib die Telefonnummer ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            label="Straße & Hausnummer"
            source="contactData.street"
            validate={required("Bitte gib die Straße und Hausnummer ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="PLZ"
            source="contactData.postalCode"
            validate={required("Bitte gib die Postleitzahl ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Stadt"
            source="contactData.city"
            validate={required("Bitte gib die Stadt ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Geburtsort"
            source="placeOfBirth"
            validate={required("Bitte gib den Geburtsort ein.")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput
            label="Geburtsdatum"
            source="dateOfBirth"
            validate={[required("Bitte gib das Geburtsdatum ein."), date(), dateNotInTheFuture()]}
            fullWidth
          />
        </Grid>
      </Grid>
      <DialogActions sx={{ padding: 0 /* ... because we are inside a <DialogContent> element */ }}>
        <Button variant="outlined" onClick={onCancel}>
          Abbrechen
        </Button>
        <SaveButton2 label="Teilnehmer hinzufügen" />
      </DialogActions>
    </Form2>
  );
}
